import React, { useContext } from 'react';

// The surface behind the nearest ChartCard or chart. Optional: outside one, the chart settings mode applies.
const ChartSurfaceContext = React.createContext<boolean | undefined>(undefined);

const ChartSurfaceProvider: React.FC<{ dark?: boolean; children: React.ReactNode }> = ({ dark, children }) => {
  const outerDark = useContext(ChartSurfaceContext);

  return <ChartSurfaceContext.Provider value={dark ?? outerDark}>{children}</ChartSurfaceContext.Provider>;
};

// An explicit `dark` wins over the nearest provided surface.
const useChartSurfaceDark = (dark?: boolean): boolean | undefined => {
  const surfaceDark = useContext(ChartSurfaceContext);

  return dark ?? surfaceDark;
};

export { ChartSurfaceProvider, useChartSurfaceDark };
